import { IconFolderOpenAngledOutline } from '@icons/IconFolderOpenAngledOutline'

export function StatementEditorEmptyResponse() {
  return (
    <div className="flex w-full flex-col items-center justify-center gap-y-10 pt-36">
      <IconFolderOpenAngledOutline size={100} className="text-muted-foreground/50" />
      <div className="text-lg text-muted-foreground">No content selected</div>
    </div>
  )
}
